var React = require('react');

function Footerfacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.76038 30.668V15.4484H14.1028L14.6782 10.2037H9.76038L9.76775 7.57863C9.76775 6.21072 9.90209 5.47776 11.9328 5.47776H14.6475V0.232422H10.3045C5.08784 0.232422 3.25172 2.77669 3.25172 7.05534V10.2043H0V15.449H3.25172V30.668H9.76038Z","fill":"#4035C3"}));
}

Footerfacebook.defaultProps = {"width":"15","height":"31","viewBox":"0 0 15 31","fill":"none"};

module.exports = Footerfacebook;

Footerfacebook.default = Footerfacebook;
